import { createBrowserRouter, Navigate } from "react-router-dom";
import AppLayout from "~/single-page/layouts/AppLayout";
import SignIn from "~/single-page/pages/SignIn";
import SignUp from "~/single-page/pages/SignUp";
import ResetPassword from "~/single-page/pages/ResetPassword";
import RequestPasswordReset from "~/single-page/pages/RequestPasswordReset";
import Events from "~/single-page/pages/Events";
import FaleConosco from "~/components/FaleConosco";
import Opportunities from "~/single-page/pages/Oportunities";
import BloodDonations from "~/single-page/pages/BloodDonations";
import CauseNgosPage from "~/single-page/pages/CauseNgos";
import ActionManagementsPage from "~/single-page/pages/ActionManagements";
import { APP_ROUTES } from "~/single-page/constants/routes";
import NGODetailPage from '~/single-page/pages/NGODetail';
import ActionManagementDetailPage from '~/single-page/pages/ActionManagementDetail';
import KnowledgeTrailsPage from '~/single-page/pages/KnowledgeTrails';
import ActiveNoticesPage from "~/single-page/pages/ActiveNotices";
import EventDetailPage from '~/single-page/pages/EventDetail';
import IncomeTaxPage from '~/single-page/pages/IncomeTax';
import OrganDonorPage from '~/single-page/pages/OrganDonor';
import CausesPage from '~/single-page/pages/Causes';
import NgosPage from '~/single-page/pages/NGOs';
import TestAnalytics from '~/components/TestAnalytics';
import PartnerPage from '~/single-page/pages/Partner';
import FoodBankPage from '~/single-page/pages/FoodBank';
import RegisterPage from '~/single-page/pages/Register';
import RegistrationStatusPage from '~/single-page/pages/RegistrationStatus';
import PrivacyPolicyPage from '~/single-page/pages/PrivacyPolicy';
import { PublicOnlyRoute, PrivateRoute } from '~/single-page/components/ProtectedRoute';
import SponsorsPage from '~/single-page/pages/Sponsors';
import SponsorsCompaniesPage from '~/single-page/pages/SponsorsCompanies';
import MovingActionsPage from '~/single-page/pages/MovingActions';
import FindYourCausePage from '~/single-page/pages/FindYourCause';

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <SponsorsCompaniesPage />,
    },
    {
      path: `${APP_ROUTES.SPONSORS_COMPANIES}`,
      element: <SponsorsCompaniesPage />,
    },
    // Rotas com AppLayout
    {
      path: "/",
      element: <AppLayout />,
      children: [
        {
          path: "/test-analytics",
          element: <TestAnalytics />,
        },
        {
          path: `${APP_ROUTES.EVENTS}`,
          element: <Events />,
        },
        {
          path: `${APP_ROUTES.EVENT}/:id`,
          element: <EventDetailPage />,
        },
        {
          path: `${APP_ROUTES.CONTACT_US}`,
          element: <FaleConosco />,
        },
        {
          path: `${APP_ROUTES.OPPORTUNITIES}`,
          element: <Opportunities />,
        },
        {
          path: `${APP_ROUTES.CAUSES}/:id/ngos`,
          element: <CauseNgosPage />,
        },
        {
          path: `${APP_ROUTES.BLOOD_DONATIONS}`,
          element: <BloodDonations />,
        },
        {
          path: `${APP_ROUTES.ACTION_MANAGEMENTS}`,
          element: <ActionManagementsPage />,
        },
        {
          path: `${APP_ROUTES.ACTION_MANAGEMENT}/:id`,
          element: <ActionManagementDetailPage />,
        },
        {
          path: `${APP_ROUTES.NGO}/:id`,
          element: <NGODetailPage />,
        },
        {
          path: `${APP_ROUTES.KNOWLEDGE_TRAILS}`,
          element: <KnowledgeTrailsPage />,
        },
        {
          path: `${APP_ROUTES.ACTIVE_NOTICES}`,
          element: <ActiveNoticesPage />,
        },
        {
          path: `${APP_ROUTES.INCOME_TAX}`,
          element: <IncomeTaxPage />,
        },
        {
          path: `${APP_ROUTES.ORGAN_DONOR}`,
          element: <OrganDonorPage />,
        },
        {
          path: `${APP_ROUTES.CAUSES}`,
          element: <CausesPage />,
        },
        {
          path: `${APP_ROUTES.NGOS}`,
          element: <NgosPage />,
        },
        {
          path: `${APP_ROUTES.PARTNERS}`,
          element: <PartnerPage />,
        },
        {
          path: `${APP_ROUTES.FOOD_BANK}`,
          element: <FoodBankPage />,
        },
        {
          path: `${APP_ROUTES.SPONSORS}`,
          element: <SponsorsPage />,
        },
        {
          path: `${APP_ROUTES.PRIVACY_POLICY}`,
          element: <PrivacyPolicyPage />,
        }
      ],
    },
    {
      path: `${APP_ROUTES.REGISTER}`,
      element: <PublicOnlyRoute><RegisterPage /></PublicOnlyRoute>,
    },
    {
      path: `${APP_ROUTES.SIGN_IN}`,
      element: <PublicOnlyRoute><SignIn /></PublicOnlyRoute>,
    },
    {
      path: `${APP_ROUTES.SIGN_UP}`,
      element: <PublicOnlyRoute><SignUp /></PublicOnlyRoute>,
    },
    {
      path: `${APP_ROUTES.REGISTRATION_STATUS}`,
      element: <PrivateRoute><RegistrationStatusPage /></PrivateRoute>,
    },
    {
      path: `${APP_ROUTES.MOVING_ACTIONS}`,
      element: <MovingActionsPage />,
    },
    {
      path: `${APP_ROUTES.FIND_YOUR_CAUSE}`,
      element: <FindYourCausePage />,
    }
  ],
  {
    future: {
      v7_skipActionErrorRevalidation: true,
      v7_startTransition: true,
      v7_relativeSplatPath: true,
      v7_partialHydration: true,
      v7_normalizeFormMethod: true,
      v7_fetcherPersist: true
    }
  }
);
